import { createAction, props } from '@ngrx/store'

const actionCompanySettingsPrefix = '[companySettings]'

export const loadCompanySettingsSuccess = createAction(
  `${actionCompanySettingsPrefix} loadCompanySettingsSuccess`,
  props<{ enabledModules: string[]; enabledCategories: string[] }>()
)
